import React from "react";
import { loadFederatedModule } from "./loadFederatedModule";

export const FederatedComponent = (
  remoteEntryFilenamePath: string,
  remoteModuleName: string,
  remoteModuleComponentPath: string,
) =>
  React.lazy(() =>
    loadFederatedModule(
      remoteEntryFilenamePath,
      remoteModuleName,
      remoteModuleComponentPath,
    ).then((mod) => ({ default: mod })),
  );
